import * as React from "react";
export class EventText extends React.PureComponent {
    render() {
        let clsMdf = "";
        this.props.modifier && this.props.modifier.forEach(mdf => {
            clsMdf += " rj-superbanner__event-text--" + mdf;
        });
        let dataUat = "superbanner-event-text";
        this.props.modifier ? this.props.modifier.forEach(mdf => {
            dataUat += `-${mdf}`;
        }) : dataUat;
        return (React.createElement("div", { className: `rj-superbanner__event-text${clsMdf}`, "data-uat": dataUat },
            React.createElement("span", null, this.props.text),
            this.props.mbnIndicator));
    }
}
//# sourceMappingURL=EventText.js.map